module.exports = __webpack_public_path__ + "pic_bizny_web_05@1x.png?9a82bd713f7ce6b693ca74276fde05dc";